const appVersion = 0.4;

export default appVersion;
